import { createContext, ReactNode } from "react";
import {
  BaseGetTradeExtraInfoDataRequest,
  TradeData,
  TradeSourceType,
} from "@shared/types";
import { useTradesBulkUpdate } from "@shared/features/trades/common/hooks";
import {
  HandleTradeActionClick,
  TradeSource,
} from "@shared/features/trades/common/types";

export const TradeActionsContext = createContext<
  | ({
      getMoveEntryErrorMessage: (tradeData: TradeData) => string | undefined;
      getSellPartiallyErrorMessage: (
        tradeData: TradeData
      ) => string | undefined;
      dropdownAlertComponent?: ReactNode;
      getEditTradeErrorMessage: (tradeData: TradeData) => string | undefined;
      getIsTradeReadOnlyAccount: (tradeData?: TradeData) => boolean;
      shareTradeImageLoading: boolean;
      shareTradeImageArgs: BaseGetTradeExtraInfoDataRequest | undefined;
      handleTradeActionClick: HandleTradeActionClick;
      getShareResultsErrorMessage: (
        tradeSource?: TradeSourceType | TradeSource,
        isInvalidOrInactive?: boolean
      ) => string | undefined;
    } & ReturnType<typeof useTradesBulkUpdate>)
  | undefined
>(undefined);
